import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  ul {
    list-style-type: none !important;
  }

  .column {
    &:first-child {
      margin-right: 20px;
      margin-left: -5px;
    }
  }
`;
